export default {
  GET_ALL_PRINTERS_LIST_SUCCESS: 'GET_ALL_PRINTERS_LIST_SUCCESS',
  GET_ALL_PRINTERS_LIST_LOADING: 'GET_ALL_PRINTERS_LIST_LOADING',
  GET_ALL_PRINTERS_LIST_REJECT: 'GET_ALL_PRINTERS_LIST_REJECT',
  GET_ALL_PRINTERS_LIST_FAILED: 'GET_ALL_PRINTERS_LIST_FAILED',

  GET_PRINTER_BY_ID_SUCCESS: 'GET_PRINTER_BY_ID_SUCCESS',
  GET_PRINTER_BY_ID_LOADING: 'GET_PRINTER_BY_ID_LOADING',
  GET_PRINTER_BY_ID_REJECT: 'GET_PRINTER_BY_ID_REJECT',
  GET_PRINTER_BY_ID_FAILED: 'GET_PRINTER_BY_ID_FAILED',

  UPDATE_PRINTER_SUCCESS: 'UPDATE_PRINTER_SUCCESS',
  UPDATE_PRINTER_LOADING: 'UPDATE_PRINTER_LOADING',
  UPDATE_PRINTER_REJECT: 'UPDATE_PRINTER_REJECT',
  UPDATE_PRINTER_FAILED: 'UPDATE_PRINTER_FAILED',

  UPDATE_ACTIVE_PRINTER_SUCCESS: 'UPDATE_ACTIVE_PRINTER_SUCCESS',
  UPDATE_ACTIVE_PRINTER_LOADING: 'UPDATE_ACTIVE_PRINTER_LOADING',
  UPDATE_ACTIVE_PRINTER_REJECT: 'UPDATE_ACTIVE_PRINTER_REJECT',
  UPDATE_ACTIVE_PRINTER_FAILED: 'UPDATE_ACTIVE_PRINTER_FAILED',

}